import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { PAYMENTTRANSACTION_API } from "@app/utils/apiUrl";

const PaymentTransaction = () => {
  const [qrContent, setQrContent] = useState("");
  const [transaction, setTransaction] = useState(null);

  const createPayment = async () => {
    const res = await fetch(PAYMENTTRANSACTION_API.CREATE_VIETQR, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        orderCode: "HD202605210001",
        customerCode: "BN001",
        amount: 500000,
        content: "Thanh toan vien phi",
        clientIp: ""
      })
    });

    const data = await res.json();

    // VietinBank trả base64QRCode là base64 của chuỗi QR
    const qrText = atob(data.base64QRCode);

    setQrContent(qrText);
    setTransaction(data);
  };

  return (
    <div>
      <button onClick={createPayment}>
        Tạo mã thanh toán
      </button>

      {qrContent && (
        <div style={{ marginTop: 24 }}>
          <h3>Quét mã để thanh toán</h3>

          <QRCodeCanvas
            value={qrContent}
            size={260}
            includeMargin={true}
          />

          <p>Số tiền: {transaction?.amount?.toLocaleString("vi-VN")} VNĐ</p>
          <p>Trạng thái: {transaction?.status}</p>
        </div>
      )}
    </div>
  );
};

export default PaymentTransaction;